module.exports = __webpack_public_path__ + "img/building.75a184c4.png";